<template>
  <div id="container">
    <div id="title">
      <b-row>
        <b-col class="no-padding">
          <h1 v-if="request.extensionid == null">Demande n°{{ request.id }}</h1>
          <h2 v-else>
            Demande n°{{ request.id }} - Prolongation de la demande n°{{
              request.extensionid
            }}
          </h2>
        </b-col>
        <b-col class="no-padding text-right boite-outils">
          <b-button
            variant="white"
            class="btn-auto mr-2"
            @click="mapStatus = !mapStatus"
          >
            <font-awesome-icon icon="map-marked-alt"></font-awesome-icon>
            Afficher / Masquer carte
          </b-button>
          <b-button
            @click="goToList()"
            variant="info"
            block
            class="btn-auto"
            id="back-list"
          >
            <font-awesome-icon icon="reply"></font-awesome-icon>
          </b-button>
          <b-tooltip target="back-list" triggers="hover" class="back-to-list"
            >Retour à la liste
          </b-tooltip>
          <b-tooltip
            target="extension_request"
            triggers="hover"
            class="back-to-list"
          >
            Prolonger la demande
          </b-tooltip>
        </b-col>
      </b-row>
    </div>
    <div
      :class="
        mapStatus == true
          ? 'block-flat block-flat-map'
          : 'block-flat block-flat-map small'
      "
    >
      <div class="block-content">
        <div id="container-map">
          <maps
            :draw="false"
            :vectorLayers="vectorLayers"
            width="calc(100%)"
          ></maps>
        </div>
      </div>
    </div>
    <div v-if="request" id="content">
      <div class="block-flat">
        <div class="info-demande">
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="8">
              <b-row class="no-margin">
                <b-col
                  v-if="request.depositDate != null"
                  cols="12"
                  sm="12"
                  md="4"
                  lg="4"
                  xl="3"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <span
                      id="2Cerfa1"
                      v-if="
                        request.cerfa1402301 != null &&
                          request.cerfa1402301.isAccessDevelopment == false &&
                          request.individualAlignmentRequest != null
                      "
                    >
                      <font-awesome-icon
                        icon="ruler-combined"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        icon="road"
                        class="ml-2"
                      ></font-awesome-icon>
                      <br />
                      Permission de voirie - Réseaux <br />et Demande
                      d'alignement
                      <b-tooltip target="2Cerfa1" triggers="hover">
                        Permission de voirie - Réseaux et Demande d'alignement
                      </b-tooltip>
                    </span>
                    <span
                      id="2Cerfa2"
                      v-if="
                        request.cerfa1402301 != null &&
                          request.cerfa1402301.isAccessDevelopment == true &&
                          request.individualAlignmentRequest != null
                      "
                    >
                      <font-awesome-icon
                        icon="ruler-combined"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        icon="archway"
                        class="ml-2"
                      ></font-awesome-icon>
                      <br />
                      Permission de voirie - Accès/Clôture <br />et Demande
                      d'alignement
                      <b-tooltip target="2Cerfa2" triggers="hover">
                        Permission de voirie - Accès/Clôture et Demande
                        d'alignement
                      </b-tooltip>
                    </span>
                    <!-- <font-awesome-icon icon="tag"></font-awesome-icon>
                    Date de dépôt-->
                    <span
                      v-if="
                        request.cerfa1402301 != null &&
                          request.individualAlignmentRequest == null
                      "
                      id="cerfa14023"
                    >
                      <span
                        v-if="
                          request.cerfa1402301 &&
                            request.cerfa1402301.isAccessDevelopment == true
                        "
                      >
                        <font-awesome-icon icon="archway"></font-awesome-icon>
                        Accès/Clôture
                        <b-tooltip target="cerfa14023" triggers="hover">
                          Cerfa n°14023*01 <br />
                          Permission de voirie
                          <span
                            v-if="
                              request.cerfa1402301.isFavorable == false &&
                                request.cerfa1402301.commentDecision != null
                            "
                          >
                            ({{ request.cerfa1402301.commentDecision }})
                          </span>
                        </b-tooltip>
                      </span>
                      <span v-else>
                        <font-awesome-icon icon="road"></font-awesome-icon>
                        Réseaux
                        <b-tooltip target="cerfa14023" triggers="hover">
                          Cerfa n°14023*01 <br />
                          Permission de voirie
                          <span
                            v-if="
                              request.cerfa1402301.isFavorable == false &&
                                request.cerfa1402301.commentDecision != null
                            "
                          >
                            ({{ request.cerfa1402301.commentDecision }})
                          </span>
                        </b-tooltip>
                      </span>
                    </span>
                    <span
                      v-if="
                        request.individualAlignmentRequest != null &&
                          request.cerfa1402301 == null
                      "
                      id="alignement"
                    >
                      <font-awesome-icon
                        icon="ruler-combined"
                      ></font-awesome-icon>
                      Demande d'alignement individuel
                      <b-tooltip target="alignement" triggers="hover"
                        >Demande d'alignement
                      </b-tooltip>
                    </span>

                    <span
                      v-if="
                        request.individualAlignmentRequest == null &&
                          request.cerfa1402301 == null
                      "
                    >
                      <font-awesome-icon
                        icon="question-circle"
                      ></font-awesome-icon>
                      Pas de demande
                    </span>
                  </p>
                  <p v-if="request.state && request.state.name" :class="'info-title statut-' + request.state.id">
                    <font-awesome-icon icon="square"></font-awesome-icon>
                    Statut : {{ request.state.name }}
                    <span v-if="request.state.id == 8 && request.completenessDate != null">
                      le {{ request.completenessDate.split(" ")[0] }}
                    </span>
                  </p>
                  <div
                    v-if="
                      request.state.id &&
                        request.reorientationMail != null &&
                        request.state.id == 11
                    "
                  >
                    Dossier réorienté à {{ request.reorientationMail }}
                  </div>
                  <div
                    v-if="request.state.id && request.state.id == 10 && request.extensionRequest != null"
                    class="mb-2"
                  >
                    <p class="info-title">
                      <font-awesome-icon icon="copy"></font-awesome-icon>
                      Demande prolongée
                    </p>
                    <b-button
                    variant="info"
                    size="sm"
                    @click="goToDossier(request.extensionRequest)"
                    >
                      Consulter la prolongation (#{{ request.extensionRequest }})
                      <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
                    </b-button>
                  </div>
                  <div
                    v-if="
                      request.state.id &&
                        request.sendToSign == true &&
                        request.state.id == 3 &&
                        (userConnected.roles.includes('ROLE_ADMIN') ||
                          userConnected.roles.includes('ROLE_INSTRUCTEUR'))
                    "
                  >
                    <b>Dossier envoyé en signature. En attente de retour</b>
                  </div>
                  Dépôt le {{ request.depositDate }}
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="5"
                  lg="5"
                  xl="4"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="info-circle"></font-awesome-icon>
                    Localisation/Demandeur
                  </p>
                  <div>
                    <font-awesome-icon
                      icon="map-marker-alt"
                    ></font-awesome-icon>
                    {{ request.addressNum }} {{ request.addressExt }}
                    {{ request.addressType }} {{ request.addressName }},
                    {{ request.addressPostalCode }}
                    {{ request.addressCity }}
                  </div>
                  <div v-if="request.petitioner">
                    <font-awesome-icon icon="user"></font-awesome-icon>
                    {{ request.petitioner.lastName }}
                    {{ request.petitioner.firstName }}
                    {{ request.petitioner.corporationName }}
                    {{ request.petitioner.corporationAgent }}
                  </div>
                  <div v-if="request.numaffaire != null">
                    <font-awesome-icon icon="briefcase"></font-awesome-icon>
                    Numéro d'affaire : {{ request.numaffaire }}
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="5"
                  lg="5"
                  xl="4"
                  class="no-padding text-center"
                  v-if="request.state && [2, 6, 7].includes(request.state.id)"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="hard-hat"></font-awesome-icon>
                    Réception
                  </p>
                  <div
                    v-if="
                      reception.option === 'Photos' && request.state.id !== 2
                    "
                  >
                    <font-awesome-icon icon="cog"></font-awesome-icon>
                    Photos
                  </div>
                  <div
                    v-if="
                      reception.acceptRdv != null &&
                        reception.option === 'Rendez-vous' &&
                        request.state.id !== 2
                    "
                  >
                    <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    Rendez-vous le <b>{{ formatDate(reception.acceptRdv) }}</b>
                  </div>
                  <div
                    v-if="
                      reception.acceptRdv == null &&
                        reception.option === 'Rendez-vous' &&
                        request.state.id !== 2
                    "
                  >
                    <font-awesome-icon icon="calendar-alt"></font-awesome-icon>
                    En attente de rendez-vous
                  </div>
                  <div v-if="request.state.id === 2">
                    <font-awesome-icon icon="check"></font-awesome-icon>
                    Travaux réceptionnés
                  </div>
                </b-col>
                <b-col
                  v-if="request.dateStart != null || request.dateEnd != null"
                  cols="12"
                  sm="12"
                  md="3"
                  lg="3"
                  xl="3"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="hard-hat"></font-awesome-icon>
                    Travaux
                  </p>
                  <div v-if="request.dateStart != null">
                    <!--                      <font-awesome-icon icon="sign-in-alt"></font-awesome-icon>-->
                    Du : {{ request.dateStart }}
                  </div>
                  <div v-if="request.dateEnd != null">
                    <!--                      <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>-->
                    Au : {{ request.dateEnd }}
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="3"
                  lg="3"
                  xl="3"
                  class="no-padding text-center"
                  v-for="doc in request.documents"
                  :key="doc.id"
                  v-if="doc.typeDocument.name == 'Arrêté de décision SIGNÉ'"
                  style="line-height: 75px"
                >
                  <b-button
                    variant="success"
                    @click="download(doc.url, doc.name)"
                  >
                    <font-awesome-icon icon="download"></font-awesome-icon>
                    Télécharger l'arrêté
                  </b-button>
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="3"
                  lg="3"
                  xl="3"
                  class="adresse-demande text-center"
                  v-if="
                    ((userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                      userConnected.roles.includes('ROLE_ADMIN')) &&
                      request.individualAlignmentRequest != null &&
                      request.individualAlignmentRequest.parapheurDecision !=
                        null) ||
                      (request.cerfa1402301 != null &&
                        request.cerfa1402301.parapheurDecision != null)
                  "
                >
                  <!-- Condition affichage parapheur cerfa -->
                  <div
                    v-if="
                      request.cerfa1402301 != null &&
                        request.cerfa1402301.parapheurDecision != null &&
                        request.cerfa1402301.commentDecision != null
                    "
                  >
                    <!-- <p
                      class="info-title"
                      style="color: green"
                      v-if="request.cerfa1402301.parapheurDecision == true"
                    >
                      <font-awesome-icon icon="signature"></font-awesome-icon>
                      Signé
                    </p> -->
                    <p
                      class="info-title"
                      style="color: red"
                      v-if="
                        request.cerfa1402301.parapheurDecision == false &&
                          request.stateId == 3
                      "
                    >
                      <font-awesome-icon icon="signature"></font-awesome-icon>
                      Refusé à la signature<br />
                      {{ request.cerfa1402301.commentDecision }}
                    </p>
                  </div>
                  <!-- Condition affichage parapheur alignement -->
                  <div
                    v-if="
                      request.individualAlignmentRequest != null &&
                        request.individualAlignmentRequest.parapheurDecision !=
                          null &&
                        request.individualAlignmentRequest.commentDecision !=
                          null
                    "
                  >
                    <!-- <p
                      class="info-title"
                      style="color: green"
                      v-if="
                        request.individualAlignmentRequest.parapheurDecision ==
                        true
                      "
                    >
                      <font-awesome-icon icon="signature"></font-awesome-icon>
                      Signé
                    </p> -->
                    <p
                      class="info-title"
                      style="color: red"
                      v-if="
                        request.individualAlignmentRequest.parapheurDecision ==
                          false
                      "
                    >
                      <font-awesome-icon icon="signature"></font-awesome-icon>
                      Refusé à la signature<br />
                      {{ request.individualAlignmentRequest.commentDecision }}
                    </p>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="4"
              class="no-padding text-right boite-outils first-boite"
              style="line-height: 75px"
            >
              <div
                class="inline-block"
                v-if="
                  (userConnected &&
                    userConnected.roles.includes('ROLE_ADMIN')) ||
                    userConnected.roles.includes('ROLE_DEMANDEUR')
                "
              >
                <b-button
                  v-if="
                    request.state.name &&
                      request.state.name === 'Transférée en complétude' &&
                      request.sendToSign != true
                  "
                  @click="editDossier(request.id)"
                  variant="warning"
                  block
                  class="btn-auto mr-2"
                  id="edit-dossier"
                >
                  <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                </b-button>
                <b-tooltip
                  v-if="
                    request.state.name &&
                      request.state.name === 'Transférée en complétude'
                  "
                  target="edit-dossier"
                  triggers="hover"
                  >Modifier ma demande
                </b-tooltip>
              </div>
              <div
                class="inline-block"
                v-if="
                  userConnected &&
                    (userConnected.roles.includes('ROLE_ADMIN') ||
                      userConnected.roles.includes('ROLE_INSTRUCTEUR')) &&
                    request &&
                    request.state &&
                    (request.state.name === 'En attente de réorientation' ||
                      request.state.name === 'Transférée pour instruction' ||
                      request.state.name === 'Complétude réalisée')
                "
              >
                <b-button
                  v-if="1 == 2"
                  @click="editDossier(request.id)"
                  variant="dark"
                  block
                  class="btn-auto mr-2"
                  id="updatedos"
                >
                  <font-awesome-icon icon="edit"></font-awesome-icon>
                </b-button>
                <b-tooltip
                  v-if="userConnected.roles.includes('ROLE_ADMIN')"
                  target="updatedos"
                  triggers="hover"
                  >Mise à jour du dossier
                </b-tooltip>
                <b-button
                  v-b-modal.redirect-folder
                  v-if="request.sendToSign !== true"
                  @click="getCityByName(request.addressCity)"
                  variant="dark"
                  block
                  class="btn-auto mr-2"
                  id="transfer"
                >
                  <font-awesome-icon icon="share-square"></font-awesome-icon>
                </b-button>
                <b-tooltip target="transfer" triggers="hover"
                  >Réorienter le dossier
                </b-tooltip>
                <!-- Modal réorientation -->
                <b-modal
                  id="redirect-folder"
                  centered
                  hide-footer
                  title="Réorienter le dossier"
                >
                  <h6 class="text-center mb-4">
                    <b>Où souhaitez-vous réorienter le dossier ?</b>
                  </h6>
                  <b-row>
                    <b-col lg="6" md="6" sm="12" cols="12">
                      <b-form-radio
                        v-model="request.reorientationMail"
                        name="radio-options-reoriente"
                        :value="city.mailMairie"
                        ><b>Commune :</b><br />
                        {{ city.name }}</b-form-radio
                      >
                    </b-col>
                    <b-col lg="6" md="6" sm="12" cols="12">
                      <b-form-radio
                        v-model="request.reorientationMail"
                        name="radio-options-reoriente"
                        value="utdsoustons@landes.fr"
                        ><b>Département :</b>
                        utdsoustons@landes.fr</b-form-radio
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        @click="
                          $bvModal.hide('redirect-folder'), orientationDossier()
                        "
                        variant="info"
                        block
                        class="btn-auto pr-4 pl-4"
                      >
                        Valider
                      </b-button>
                    </b-col>
                    <b-col lg="5" md="5" sm="3" cols="12"></b-col>
                    <b-col>
                      <b-button
                        @click="$bvModal.hide('redirect-folder')"
                        variant="secondary"
                        block
                        class="btn-auto pr-4 pl-4"
                      >
                        Annuler
                      </b-button>
                    </b-col>
                  </b-row>
                </b-modal>
              </div>
              <div
                class="inline-block"
                v-if="
                  (userConnected.roles.includes('ROLE_ADMIN') ||
                    userConnected.roles.includes('ROLE_INSTRUCTEUR')) &&
                    request &&
                    request.state &&
                    request.state.id != 8 &&
                    request.state.id != 4 &&
                    request.state.id != 5 &&
                    request.state.id != 11
                "
              >
                <b-modal
                  @ok="runIfOkClickedTransfertDossierDemandeur()"
                  cancel-title="Annuler"
                  id="modal_compl"
                  size="lg"
                  title="Complétude"
                >
                  <b-alert show variant="warning">
                    Veuillez cocher les documents qui n'ont pas correctement été
                    saisis, ou qui n'ont pas été transmis, servez vous aussi de
                    l'espace commentaire pour donner des précisions sur la
                    demande de complétude :
                  </b-alert>
                  <!-- <b-form-checkbox-group
                    v-model="missingDocuments"
                    :options="markMandatoryTypesDocs"
                    value-field="id"
                    text-field="name"
                    class="popup-custom-checkbox"
                    stacked
                    html
                  >
                  </b-form-checkbox-group> -->
                  <div class="popup-custom-checkbox">
                    <b-form-checkbox
                      v-for="option in markMandatoryTypesDocs"
                      :key="option.id"
                      v-model="missingDocuments"
                      :value="option.id"
                      :disabled="option.disabled"
                    >
                      <span v-html="option.name"></span>
                    </b-form-checkbox>
                  </div>
                  <label style="padding-top: 30px" for="comment">
                    Commentaires :
                  </label>
                  <b-form-textarea
                    v-model="request.comment"
                    id="comment"
                  ></b-form-textarea>
                  <label for="date-completude">
                    Date de mise en complétude:
                  </label>
                  <b-form-datepicker id="date-completude" v-model="request.completenessDate"></b-form-datepicker>
                </b-modal>

                <b-button
                  v-b-tooltip="'Demande de complétude'"
                  v-if="
                    request.sendToSign !== true &&
                      (request.state.id == 2 || request.state.id == 3)
                  "
                  v-b-modal.modal_compl
                  variant="warning"
                  block
                  class="btn-auto mr-2"
                  id="transfer-dmd"
                >
                  <font-awesome-icon icon="sync"></font-awesome-icon>
                </b-button>
              </div>
              <div
                class="inline-block"
                v-if="
                  (userConnected &&
                    (userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                      userConnected.roles.includes('ROLE_ADMIN')) &&
                    request.state &&
                    request.state.name === 'Transférée pour instruction') ||
                    request.state.name == 'Complétude réalisée'
                "
              >
                <b-button
                  v-b-tooltip="'Rendre une décision'"
                  @click="showModalDecisionAlignement()"
                  v-if="
                    (userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                      userConnected.roles.includes('ROLE_ADMIN')) &&
                      request.individualAlignmentRequest != null &&
                      request.sendToSign != true
                  "
                  variant="success"
                  block
                  class="btn-auto mr-2"
                  id="decision-alignement"
                >
                  <font-awesome-icon icon="ruler-combined"></font-awesome-icon>
                </b-button>
                <b-button
                  v-b-tooltip="'Rendre une décision'"
                  v-if="
                    (userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                      userConnected.roles.includes('ROLE_ADMIN')) &&
                      request.cerfa1402301 != null &&
                      request.sendToSign != true
                  "
                  @click="
                    request.cerfa1402301.isAccessDevelopment == true
                      ? showModalDecisionPermissionVoirieAcces()
                      : showModalDecisionPermissionVoirieReseau()
                  "
                  variant="success"
                  block
                  class="btn-auto mr-2"
                  id="decision-cerfa14023"
                >
                  <font-awesome-icon
                    icon="road"
                    v-if="request.cerfa1402301.isAccessDevelopment == false"
                  ></font-awesome-icon>
                  <font-awesome-icon icon="archway" v-else></font-awesome-icon>
                </b-button>
                <decision-alignement v-model="decision_modal_alignement" />
                <decision-permission-voirie-acces
                  v-model="decision_modal_permission_voirie_acces"
                />
                <decision-permission-voirie-reseau
                  v-model="decision_modal_permission_voirie_reseau"
                />
              </div>

              <!-- Double cerfa -->
              <b-button
                v-if="request.comment != null && request.stateId == 8"
                v-b-modal.modal-comment
                variant="success"
                block
                class="btn-auto mr-2"
                id="comment-list"
              >
                <font-awesome-icon icon="comment"></font-awesome-icon>
              </b-button>
              <b-tooltip
                target="comment-list"
                triggers="hover"
                class="comment-list"
              >
                Commentaires
              </b-tooltip>
              <b-modal
                id="modal-comment"
                title="Commentaires"
                size="lg"
                hide-footer
                header-bg-variant="warning"
                header-text-variant="white"
              >
                <div v-if="request.comment != null" class="info-demande">
                  <p class="info-title">Commentaire Complétude de pièce :</p>
                  <p>{{ request.comment }}</p>
                </div>
                <div
                  v-if="request.commentDecision != null"
                  class="info-demande"
                >
                  <p class="info-title">Commentaire Décision :</p>
                  <p>{{ request.commentDecision }}</p>
                </div>
              </b-modal>
              <b-modal
                @ok="extensionDossier()"
                cancel-title="Annuler"
                id="modal_prolongation"
                v-model="prolongation_modal"
                size="lg"
                :title="'Demande de prolongation de la demande n°' + request.id"
              >
                <div class="form-group">
                  <p>
                    <b><u>Saisissez les nouvelles dates de travaux</u></b>
                  </p>
                  <b-row>
                    <b-col
                      xl="4"
                      lg="6"
                      md="6"
                      sm="12"
                      cols="12"
                      class="no-padding"
                    >
                      <label class="control-label"
                        >Date prévue de début d'application
                        <span class="red">*</span> :</label
                      >
                    </b-col>
                    <b-col xl="6" lg="6" md="6" sm="12" cols="12">
                      <ValidationProvider
                        mode="lazy"
                        v-slot="{ errors }"
                        rules="required"
                        name="date de début"
                      >
                        <b-form-datepicker
                          hide-header
                          :start-weekday="1"
                          v-model="request.dateStart"
                          placeholder="Date prévue de début d'application"
                          @input="calcNumberDays($event)"
                          today-button
                          today-button-variant="warning"
                          :state="errors[0] ? false : null"
                          label-help=""
                          label-today-button="Aujourd'hui"
                          required
                        ></b-form-datepicker>
                        <div class="error">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </b-col>
                    <b-col
                      xl="4"
                      lg="6"
                      md="6"
                      sm="12"
                      cols="12"
                      class="no-padding"
                    >
                      <label class="control-label"
                        >Date prévue de fin d'application
                        <span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col xl="6" lg="6" md="6" sm="12" cols="12">
                      <ValidationProvider
                        mode="lazy"
                        v-slot="{ errors }"
                        rules="required"
                        name="date de fin"
                      >
                        <b-form-datepicker
                          required
                          hide-header
                          :state="errors[0] ? false : null"
                          :start-weekday="1"
                          v-model="request.dateEnd"
                          @input="calcNumberDays($event)"
                          placeholder="Date prévue de fin d'application"
                          today-button
                          today-button-variant="warning"
                          label-help=""
                          label-today-button="Aujourd'hui"
                        ></b-form-datepicker>
                        <div class="error">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </b-col>
                    <b-col
                      xl="4"
                      lg="6"
                      md="6"
                      sm="12"
                      cols="12"
                      class="no-padding"
                    >
                      <label class="control-label">Nombre de jours : </label>
                    </b-col>
                    <b-col xl="6" lg="6" md="6" sm="12" cols="12">
                      <b-form-input
                        :disabled="true"
                        type="number"
                        v-model="request.numberDays"
                      />
                    </b-col>
                  </b-row>
                  <p v-if="showErrorNumberDays" style="color: red">
                    La date de fin de travaux ne peut pas être inférieure à la
                    date de début des travaux
                  </p>
                </div>
              </b-modal>
              <b-button
                v-b-tooltip="'Annuler la demande'"
                v-b-modal.cancel-works
                v-if="[3, 4, 6, 7, 8, 9].includes(request.state.id)"
                variant="danger"
                block
                class="btn-auto mr-2"
              >
                <font-awesome-icon icon="times" size="lg"></font-awesome-icon>
              </b-button>
              <b-modal id="cancel-works" centered hide-footer title="Attention">
                <h6 class="text-center mb-3">
                  <b>Voulez-vous annuler la demande de travaux ?</b>
                </h6>
                <b-row>
                  <b-col>
                    <b-button
                      @click="
                        $bvModal.hide('cancel-works'), cancelFolder(request)
                      "
                      variant="info"
                      block
                      class="btn-auto pr-5 pl-5"
                    >
                      Oui
                    </b-button>
                  </b-col>
                  <b-col lg="3" md="10" sm="12" cols="12"></b-col>
                  <b-col>
                    <b-button
                      @click="$bvModal.hide('cancel-works')"
                      variant="secondary"
                      block
                      class="btn-auto pr-5 pl-5"
                    >
                      Non
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Bouton Réception -->

              <reception-permission-voirie-reseau
                v-model="reception_modal_permission_voirie_reseau"
              />
              <reception-permission-voirie-acces
                v-model="reception_modal_permission_voirie_acces"
              />
              <span v-if="request.cerfa1402301 != null">
                <b-button
                  v-b-tooltip="'Demande de réception des travaux'"
                  @click="
                    request.cerfa1402301.isAccessDevelopment == true
                      ? showModalReceptionPermissionVoirieAcces()
                      : showModalReceptionPermissionVoirieReseau()
                  "
                  v-if="
                    (userConnected.roles.includes('ROLE_DEMANDEUR') &&
                      request.state.id == 4) ||
                      (userConnected.roles.includes('ROLE_DEMANDEUR') &&
                        (request.state.id == 6 || request.state.id == 7)) ||
                      (userConnected.roles.includes('ROLE_DEMANDEUR') &&
                        request.state.id == 12) ||
                      (userConnected.roles.includes('ROLE_INSTRUCTEUR') &&
                        request.state.id == 6) ||
                      (userConnected.roles.includes('ROLE_ADMIN') &&
                        request.state.id == 4) ||
                      (userConnected.roles.includes('ROLE_ADMIN') &&
                        request.state.id == 6) ||
                      (userConnected.roles.includes('ROLE_ADMIN') &&
                        request.state.id == 12) ||
                      (userConnected.roles.includes('ROLE_ADMIN') &&
                        request.state.id == 6)
                  "
                  variant="info"
                  block
                  class="btn-auto mr-2"
                >
                  <font-awesome-icon icon="hard-hat"></font-awesome-icon>
                </b-button>
              </span>
              <b-button
                v-b-tooltip="'Réception des travaux'"
                @click="showModalReceptionAvis()"
                v-if="
                  [7, 6, 4, 12].includes(request.state.id) &&
                    (userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                      userConnected.roles.includes('ROLE_ADMIN'))
                "
                variant="info"
                block
                class="btn-auto mr-2"
              >
                <font-awesome-icon icon="hard-hat"></font-awesome-icon>
              </b-button>
              <reception-avis v-model="reception_modal_avis" :reportingRoadDisturbance="reportingRoadDisturbance" />
              <!-- Bouton désordre de voirie -->
              <!-- TODO: vérifier qu'on n'a pas atteint la fin du delai de garantie -->
              <b-button
                v-b-tooltip="'Désordre de voirie'"
                v-b-modal.confirm-road-disturbance
                v-if="
                      request.cerfa1402301 != null
                      &&
                      request.individualAlignmentRequest == null
                      &&
                      request.state.id == 2 
                      && 
                      (userConnected.roles.includes('ROLE_INSTRUCTEUR') || userConnected.roles.includes('ROLE_ADMIN'))
                      "
                variant="danger"
                class="mr-2"
              >
                <font-awesome-icon icon="road"></font-awesome-icon>
              </b-button>
              <!-- FIN Bouton désordre de voirie -->
              <!-- Modale Confirmation désordre de voirie -->
              <b-modal id="confirm-road-disturbance" hide-footer title="Confirmation">
                <p>Avez-vous constaté un désordre de voirie ?</p>
                <b-row>
                  <b-col>
                    <b-button
                      variant="success"
                      @click="$bvModal.hide('confirm-road-disturbance'), reportRoadDisturbance()"
                      block
                    >
                      Oui
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      variant="primary"
                      @click="$bvModal.hide('confirm-road-disturbance')"
                      block
                    >
                      Non
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- FIN Modale Confirmation désordre de voirie -->
              <div class="inline-block">
                <b-button
                  v-b-tooltip="'Impression du cerfa'"
                  class="mr-2"
                  v-if="request.individualAlignmentRequest != null"
                  @click="printCerfa('alignement', request.id)"
                  variant="white"
                  id="print_alignement"
                  :disabled="
                    request.individualAlignmentRequest == null &&
                      request.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon icon="print"></font-awesome-icon>
                </b-button>
                <b-button
                  v-if="
                    request.cerfa1402301 != null &&
                      request.cerfa1402301.isAccessDevelopment == null
                  "
                  @click="printCerfa('14023', request.id)"
                  variant="white"
                  id="print_travaux"
                  v-b-tooltip="'Impression du cerfa'"
                  :disabled="
                    request.individualAlignmentRequest == null &&
                      request.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon icon="print"></font-awesome-icon>
                </b-button>
                <b-button
                  v-if="
                    request.cerfa1402301 != null &&
                      request.cerfa1402301.isAccessDevelopment != null
                  "
                  @click="printCerfa('14023', request.id)"
                  variant="white"
                  class="mr-2"
                  id="print_acces"
                  v-b-tooltip="'Impression du cerfa'"
                  :disabled="
                    request.individualAlignmentRequest == null &&
                      request.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon icon="print"></font-awesome-icon>
                </b-button>
                <!-- TODO peut etre pas pour les alignements -->
                <b-button
                  v-b-tooltip="'Prolonger la demande'"
                  v-if="
                    request.individualAlignmentRequest == null &&
                      (request.state.id == 4 || request.state.id == 12) &&
                      (userConnected.roles.includes('ROLE_ADMIN') ||
                        userConnected.roles.includes('ROLE_INSTRUCTEUR') ||
                        userConnected.roles.includes('ROLE_DEMANDEUR'))
                  "
                  @click="showModalProlongation()"
                  variant="warning"
                  class="mr-2 ml-2"
                  id="extension_request"
                >
                  <font-awesome-icon icon="copy"></font-awesome-icon>
                </b-button>
              </div>
              <!-- <b-col class="no-padding text-right">
                <b-button class="ml-2" variant="primary" @click="doArrete()" :disabled="showBtnGen">Générer l'arrêté
                </b-button>
                <b-button class="ml-2" variant="primary" @click="doArrete()" :disabled="showBtnGen">Editer l'arrêté
                </b-button>
              </b-col> -->
            </b-col>
          </b-row>
        </div>
        <div class="detail-demande">
          <documents
            :showValid="false"
            xs="4"
            sm="4"
            xl="4"
            lg="4"
            md="4"
            :card="false"
            :replace="false"
            :remove="false"
            :add="false"
            :documents="request.documents"
            :requestid="request.id"
          ></documents>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index.js";
import maps from "../components/Maps.vue";
import DecisionAlignement from "./Decisions/DecisionAlignement.vue";
import DecisionPermissionVoirieAcces from "./Decisions/DecisionPermissionVoirieAcces.vue";
import DecisionPermissionVoirieReseau from "./Decisions/DecisionPermissionVoirieReseau.vue";
import ReceptionPermissionVoirieAcces from "./Decisions/ReceptionPermissionVoirieAcces.vue";
import ReceptionPermissionVoirieReseau from "./Decisions/ReceptionPermissionVoirieReseau.vue";
import ReceptionAvis from "./Decisions/ReceptionAvis.vue";
import documents from "../components/Documents.vue";
import cerfa_popup from "./Cerfa.vue";
import Vue from "vue";
import Vuex from "vuex";
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox,
} from "vuelayers/lib/ol-ext";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Circle from "ol/style/Circle";
import Point from "ol/geom/Point";
import VuePdfPreview from "vue-pdf";
import historyTimeline from "../components/historyTimeline.vue";

export default {
  watch: {
    mapStatus: {
      handler: function(val) {
        if (val == true) {
          this.$nextTick(() => {
            if (window.Event) {
              window.Event.$emit("refreshMap");
            }
          });
        }
      },
    },
  },

  async mounted() {
    let decrypted = this.$aes.decrypt(this.$route.params.id);

    await this.getDossier(decrypted);
    await this.getReception(decrypted);

    if (
      this.userConnected.roles.includes("ROLE_DEMANDEUR") &&
      this.request.state.id === 6 &&
      (this.reception.rdv1 || this.reception.rdv2 || this.reception.rdv3)
    ) {
      await this.$nextTick();
      this.reception_modal_permission_voirie_reseau = true;
    }

    let type = [];
    if (!!this.request.cerfa1402301) {
      type.push("cerfa14023");

      this.request.cerfa1402301.decisionDebitLS = 3;
    }

    await this.getDocumentsFromCerfa(type);

    this.$nextTick(function() {
      if (this.$route.params.id) {
        let decrypted = Vue.prototype.$aes.decrypt(this.$route.params.id);
        this.getManagers(decrypted);
      }
      setTimeout(function() {
        window.Event.$emit("zoomLayer", "DossierLineLayer,DossierPointLayer");
      }, 3000);
    });
  },
  name: "Detail",
  data: () => ({
    mapStatus: true,
    prolongation_modal: false,

    optionsReorientation: [
      { text: "Commune", value: "commune" },
      { text: "Département", value: "departement" },
    ],
    decision_modal_alignement: false,
    decision_modal_permission_voirie_acces: false,
    decision_modal_permission_voirie_reseau: false,
    reception_modal_permission_voirie_acces: false,
    reception_modal_permission_voirie_reseau: false,
    reception_modal_avis: false,
    missingDocuments: [],
    manager: null,
    pdfToView: "",
    viewerPdf: false,
    viewerDoc: false,
    numPages: 1,
    docToView: "",
    imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
    pdfMimeType: ["application/pdf"],
    DocMimeType: [
      "application/octet-stream",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.oasis.opendocument.text",
      "application/vnd.ms-powerpoint",
      "text/csv",
      "application/vnd.ms-office",
      "text/plain",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
    forceHideArreteBtn: null,
    reportingRoadDisturbance: false,
  }),
  components: {
    "reception-avis": ReceptionAvis,
    "reception-permission-voirie-reseau": ReceptionPermissionVoirieReseau,
    "reception-permission-voirie-acces": ReceptionPermissionVoirieAcces,
    "decision-alignement": DecisionAlignement,
    "decision-permission-voirie-acces": DecisionPermissionVoirieAcces,
    "decision-permission-voirie-reseau": DecisionPermissionVoirieReseau,
    maps: maps,
    cerfa_popup: cerfa_popup,
    documents: documents,
    "vue-pdf-preview": VuePdfPreview,
    "history-timeline": historyTimeline,
  },
  methods: {
    showModalReceptionPermissionVoirieAcces() {
      this.reception_modal_permission_voirie_acces = true;
    },
    showModalReceptionAvis() {
      this.reception_modal_avis = true;
    },
    showModalReceptionPermissionVoirieReseau() {
      this.reception_modal_permission_voirie_reseau = true;
    },

    showModalDecisionAlignement() {
      this.decision_modal_alignement = true;
    },
    showModalDecisionPermissionVoirieAcces() {
      this.decision_modal_permission_voirie_acces = true;
    },
    showModalDecisionPermissionVoirieReseau() {
      this.decision_modal_permission_voirie_reseau = true;
    },
    cancelFolder(dossier) {
      dossier.state_id = 1;
      dossier.stateId = 1;
      this.updateDossier(dossier);
      Vue.prototype.$awn.success("Travaux annulés");
    },
    reportRoadDisturbance() {
      this.reportingRoadDisturbance = true;
      this.reception_modal_avis = true;
    },

    showModalProlongation() {
      //préparation remise à 0 des dates et du nombre de jour
      this.request.numberDays = null;
      this.request.dateStart = null;
      this.request.dateEnd = null;
      this.prolongation_modal = true;
    },
    formatDate(date) {
      const dateObject = new Date(date);
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return dateObject.toLocaleDateString("fr-FR", options);
    },
    calcNumberDays(value) {
      if (this.request.dateStart != null && this.request.dateEnd != null) {
        let date1 = new Date(this.request.dateStart);
        let date2 = new Date(this.request.dateEnd);
        let Difference_In_Days =
          (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
        this.request.numberDays = Difference_In_Days + 1;
      }
    },
    download(doc, name) {
      Vue.axios({
        method: "get",
        url: doc,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, name);
        })
        .catch(() => console.log("error occured"));
    },

    forceFileDownload(response, name) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    open(doc) {
      if (this.imageMimeType.includes(doc.mimeType)) {
        if (doc.typeDocument.id == 17) {
          window.open(doc.url);
        } else {
          const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
          viewer.show();
        }
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
        window.open(this.docToView);
      }
    },
    runIfOkClickedTransfertDossierDemandeur() {
      this.request.stateId = 8;
      this.request.missingDocuments = this.missingDocuments;
      this.updateDossier(this.request);
    },
    orientationDossier() {
      this.request.stateId = 11;
      this.updateDossier(this.request);
      router.push({ name: "Dossiers" });
    },
    extensionDossier() {
      Vue.prototype.$awn.confirm(
        "Êtes vous sûr de vouloir dupliquer cette demande pour prolonger l'autorisation des travaux ?",
        async () => {
          await this.extension(this.request);
        },
        async () => {
          this.prolongation_modal = true;
        }
      );
    },
    editDossier(id) {
      router.push({ name: "updatedossier", params: { id: id } });
    },
    goToList() {
      router.push({ name: "Dossiers" });
    },
    printCerfa(type, id) {
      Vue.axios
        .get(window.urlapi + "request/" + id + "/pdf/" + type)
        .then((response) => {
          window.open(response.data.message);
        });
    },
    goToDossier(id) {
      let encrypted = this.$aes.encrypt(id.toString());
      const routeData = router.resolve({ name: "Dossier", params: { id: encrypted } });
      window.open(routeData.href, '_blank');
    },
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "getManagers",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
    ]),

    ...Vuex.mapActions("Document", ["getDocumentsFromCerfa", "sendDocument"]),
    ...Vuex.mapActions("Contact", ["getCityByName"]),
  },
  computed: {
    showErrorNumberDays() {
      let disabled = false;
      if (
        this.request.type != 2 &&
        (this.request.numberDays < 0 || this.request.numberDays == 0)
      ) {
        disabled = true;
      }

      return disabled;
    },

    arretes() {
      let data = [];
      this.request.documents.forEach(function(element) {
        if (element.typeDocument.id == 21 || element.typeDocument.id == 20) {
          data.push(element);
        }
      });
      return data;
    },

    request: {
      get() {
        return this.dossierSelected;
      },
      set(value) {
        this.setDossier(value);
      },
    },

    typesDocs: {
      get() {
        return this.typeDocuments;
      },
    },
    vectorLayers: function() {
      let tab = [];
      if (typeof this.request !== "undefined") {
        tab.push({
          vectorZIndex: 100,
          ref: "DossierPointLayer",
          visible: true,
          features: this.request.point,
          factory: function() {
            return (feature) => {
              if (feature.getProperties().marker) {
                return [
                  new Style({
                    zIndex: 150,
                    image: new Icon({
                      src: require("../img/marker-map/" +
                        (feature.getProperties().marker || "demande.png")),
                      scale: 0.5,
                    }),
                  }),
                ];
              } else {
                return [];
              }
            };
          },
          click: function(feature) {},
        });

        tab.push({
          vectorZIndex: 99,
          ref: "DossierLineLayer",
          visible: true,
          features: this.features,
          factory: function() {
            return (feature) => {
              return [
                new Style({
                  zIndex: 100,
                  image: new Circle({
                    radius: 5,
                    stroke: new Stroke({
                      width: 6,
                      color: "#fbc02d",
                    }),
                    fill: new Fill({
                      color: "#fbc02d",
                    }),
                  }),
                  stroke: new Stroke({
                    width: 6,
                    color: "#fbc02d",
                  }),
                  fill: new Fill({
                    color: "rgba(255,255,255,0.5)",
                  }),
                }),
              ];
            };
          },
          click: function(feature) {},
        });
      }

      return tab;
    },
    
    // isModalOkDisabled() {
    //   const mandatoryIds = [85, 101];
    //   return !mandatoryIds.every(id => this.missingDocuments.includes(id));
    // },

    markMandatoryTypesDocs() {
      const mandatoryIds = []; // 85, 101
      return (this.typesDocs || []).map(option => ({
        ...option,
        name: mandatoryIds.includes(option.id)
          ? `${option.name} <span style="color: red; font-style: italic;">* obligatoire</span>`
          : option.name
      }));
    },

    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),

    ...Vuex.mapGetters("Cerfa", ["alignement"]),
    ...Vuex.mapGetters("Contact", ["city"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Document", ["typeDocuments"]),
  },
};
</script>
